// 관리자 등급 (상위 → 하위 순) : MASTER > AAA > BBB > CCC > GUEST
export const ADMIN_GRADES = ['MASTER', 'AAA', 'BBB', 'CCC', 'GUEST'] as const;

export type AdminGradeType = (typeof ADMIN_GRADES)[number];

// 설정(paths.system.*) 접근 및 관리자 계정 등록·수정이 가능한 등급
export const ADMIN_MANAGE_GRADES: readonly AdminGradeType[] = ['MASTER', 'AAA'];

// 허용 등급 포함 여부
export const hasGrade = (grade: string | null | undefined, allowedGrades: readonly AdminGradeType[]): boolean =>
	!!grade && allowedGrades.includes(grade as AdminGradeType);

// 관리자 계정 관리(설정 메뉴 접근 포함) 권한 보유 여부
export const canManageAdmins = (grade: string | null | undefined): boolean => hasGrade(grade, ADMIN_MANAGE_GRADES);
